
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gCUqtW85oMkqO5jh1knnFXb9i5y6t9LaITGlB3J6jCmkMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexhtGzu5EEBiP1dnkX_45pZk0OPnQD_45ktZ1ARC6LbKTRyXQMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchGjLIaroYULEBG3QoqTb7D55ssEKu8U09rRfZIKq_WCkMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as index7HSD7ZkYLSao2mQnqijj6s4BHgOVtobdw9ErHKw_459u8Meta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93bsL2KNDJK7Y7n2EiVHEMG0dIiAHp2hRx_sAaOGUgAqUMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexA4_45T5tx38k_45gmlioWMAbKio9Y6rUnkPgCQNnIXtjnm8Meta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93OB_DQ7W8LZPtKyxIzrPNyHZumnHFMpqgap4tY_45V9MAIMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexEaUq9BYQwaozfku6AZxh77F7fAlo_45RD6bCyElEKbyAcMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_935LrDs7BJm_45S79Qqv5LgnHDTol5aN_8V19Vu3Fx3s68UMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexpVebFNKmbeUU1fpxPQKfSy9v0gZqqpKIMq6lwq8L04IMeta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexPmc1Nlv_45ejQV6fy66a_45ZLWdFvUzTcrtQVBwt17LUjF4Meta } from "/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexA4_45T5tx38k_45gmlioWMAbKio9Y6rUnkPgCQNnIXtjnm8Meta || {},
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexEaUq9BYQwaozfku6AZxh77F7fAlo_45RD6bCyElEKbyAcMeta || {},
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexpVebFNKmbeUU1fpxPQKfSy9v0gZqqpKIMq6lwq8L04IMeta || {},
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexPmc1Nlv_45ejQV6fy66a_45ZLWdFvUzTcrtQVBwt17LUjF4Meta || {},
    component: () => import("/codebuild/output/src37502698/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]